import {Button,CircularProgress, Divider} from '@material-ui/core';
import { Grid, TextField, Typography} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import {useDispatch} from 'react-redux';
import * as userActions from '../../actions/authenticationActions';
import {useHistory} from 'react-router-dom';
import {LOGIN_PAGE_TEXTS} from '../../utility';


const UiInput = makeStyles({
  root : {
    "& .MuiInputBase-input": {
      borderRaduis: '4px',
      border: 'none',
      boxShadow: '0px 1px 6px #7784945e',
      padding: '5px 10px',
      margin: 0
  },
  "& .MuiInputBase-input:focus": {
      boxShadow:'none',
      outline:'none'
  },
  }
});


function LoginForm(props){
    const uiInputClass = UiInput().root;
    const dispatch = useDispatch();
    const history = useHistory();
    const [sEmail, setEmail] = React.useState();
    const [sPassword, setPassword] = React.useState();
    const [loginInProgress, setLoginInProgress] = React.useState(false);

    const loginDispatch = () => {
      if(sEmail && sPassword){
        setLoginInProgress(true);
        dispatch(userActions.loginUser(sEmail,sPassword,props.openSnackbar,setLoginInProgress));
      }
    }

    const loadBriefView = () => {
      history.push({
        pathname: '/loadBrief',
        state: { openSnackbar: props.openSnackbar }
      });
    }
    
    return(
        <Grid container xs="12" md="12" direction="column" alignItems="center" justify="center" spacing={1} style={{position:'absolute',top:'8rem'}}>
            <Grid item>
            <Typography variant="h6" color="primary" style={{fontWeight:'bold',textAlign:'center'}}>{LOGIN_PAGE_TEXTS.SIGN_IN_TEXT}</Typography>
            </Grid>
            <Grid item>
                <TextField
                className={uiInputClass}
                id="standard-full-width"
                label={LOGIN_PAGE_TEXTS.EMAIL_TEXTFIELD_LABAL_TEXT}
                style={{ margin: 8 }}
                placeholder={LOGIN_PAGE_TEXTS.EMAIL_TEXTFIELD_PLACEMENT_TEXT}
                type="email"
                fullWidth
                value={sEmail}
                onChange={(event) => {setEmail(event.target.value)}}
                margin="normal"
                InputLabelProps={{
                    shrink: true,
                }}
                />
            </Grid>
          <Grid item>
            <TextField
                className={uiInputClass}
                id="standard-full-width"
                label={LOGIN_PAGE_TEXTS.PASSWORD_TEXTFIELD_LABAL_TEXT}
                type="password"
                value={sPassword}
                onChange={(event) => {setPassword(event.target.value)}}
                style={{ margin: 8 }}
                placeholder={LOGIN_PAGE_TEXTS.PASSWORD_TEXTFIELD_PLACEMENT_TEXT}
                fullWidth
                margin="normal"
                InputLabelProps={{
                    shrink: true,
                }}
                />
          </Grid>
          <Grid item alignItems="center" justify="center" style={{textAlign:'center'}}>
            <Button variant="contained" color="primary" size="small" disabled={loginInProgress} onClick={loginDispatch}>
             {(!loginInProgress) ? LOGIN_PAGE_TEXTS.SIGN_IN_TEXT : <CircularProgress size={24} />}   
            </Button>
          </Grid>
          <Grid item>
            <Divider/>
            <a variant="subtitle2" onClick={loadBriefView} className="link" style={{textDecoration:'underline',cursor:'pointer'}}>{LOGIN_PAGE_TEXTS.LOAD_BRIEF_BUTTON_TEXT}</a>
          </Grid>
        </Grid>
    );

}

export default LoginForm;